import { createApi } from '@reduxjs/toolkit/query/react'
import { ADD_ASSESSMENT_GOALS_STRATEGY, CHATTER_REPORTS_PROGRAM_LIST, DELETE_ASSESSMENT_GOALS_STRATEGY, GET_REPORT_ASSESMENT_FEEDBACK, SUBMIT_ASSESSMENT_REPORT, SUBMIT_CHATTER_CONSULTATION_REPORT, SUBMIT_CONSULTATION_REPORT, SUBMIT_INDIVIDUAL_SESSION_REPORT, SUBMIT_SCHOOL_DISCHARGE_SCREENING_REPORT } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolClientsApi } from '../school.client';
import { resourceApi } from "store/services/resource";
import { chatterClientsApi } from "../chatter";

export const chatterReportsApi = createApi({
    reducerPath: 'chatterReportsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/reports",
    }),
    tagTypes: [],
    endpoints: (builder) => ({

        submitChatterConsulatitonReport: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "PATCH",
                url: `${SUBMIT_CHATTER_CONSULTATION_REPORT}/${clientId}`,
                data
            }),
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(chatterClientsApi.util.invalidateTags(['ChatterClientDetails']));
                    dispatch(resourceApi.util.invalidateTags(["reportsList"]));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),

        getChatterReportProgramsList: builder.query({
            query: ({ search = "", page = 1, limit = 10, assignedTherapistId = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${CHATTER_REPORTS_PROGRAM_LIST}`,
                data: {
                    search,
                    page,
                    limit,
                    sort,
                    assignedTherapistId
                }
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

    })
})

export const {
    useSubmitChatterConsulatitonReportMutation,
    useGetChatterReportProgramsListQuery
} = chatterReportsApi;